// poster
export const unavailable =
  "https://www.movienewz.com/img/films/poster-holder.jpg";

// backdrop
export const unavailableBackdrop =
  "https://user-images.githubusercontent.com/10515204/56117400-9a911800-5f85-11e9-878b-3f998609a6c8.jpg";
